import React from 'react';
import Icon from '../../../components/AppIcon';
import { useCompany } from '../../../components/context/CompanyContext';


const ConfirmationHeader = () => {
  const { company } = useCompany();

  return (
    <div className="text-center animate-fade-in">
      <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-full mb-6 shadow-lg animate-scale-in">
        <Icon name="CheckCircle" size={40} color="white" />
      </div>
      
      <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4">
        Booking Confirmed!
      </h1>
      
      <p className="text-muted-foreground text-base md:text-lg font-caption max-w-2xl mx-auto">
        Thank you for choosing {company.name}. Your appointment has been successfully scheduled.
        We've sent a confirmation email with all the details.
      </p>
    </div>
  );
};

export default ConfirmationHeader;